import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { apiUrl } from "../../config.js"
import { AuthService } from '../../services/auth-service'
import { Grid, Icon,Dimmer, Loader, Message } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import { Helmet } from "react-helmet";
import ReportButton from "./report-button"
import ReportButtonMonthly from "./report-button-monthly"

import * as qs from "query-string";
import ReactGA from 'react-ga';
import moment from "moment";
import {toast} from 'react-toastify';
import { BreadcrumbContext } from '../../components/header/breadcrumbcontext'; // Adjust the path as necessary


function mapStateToProps(state) {
    return {

    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {

    };
}

const authService = new AuthService();


class Reports extends Component {
    static contextType = BreadcrumbContext;

    state = {
        
        downloadingReport : false,
        sitereportToDate : moment().subtract(1,'months').endOf('month').format("DD/MM/YYYY"),
        sitereportFromDate: moment().subtract(1,'months').endOf('month').add(-24, 'months').format("DD/MM/YYYY"),
        casereportToDate: moment().format("DD/MM/YYYY"),
        casereportFromDate: moment().subtract(1,'months').endOf('month').add(-24, 'months').format("DD/MM/YYYY"),
        costconstrackerToDate: moment().format("DD/MM/YYYY"),
        costconstrackerFromDate: moment().subtract(1,'months').endOf('month').add(-24, 'months').format("DD/MM/YYYY"),
        supplierinvoicereportToDate: moment().format("DD/MM/YYYY"),
        supplierinvoicereportFromDate: moment().add(-3, 'months').format("DD/MM/YYYY"),
        hhdatareportToDate: moment().format("DD/MM/YYYY"),
        hhdatareportFromDate: moment().add(-3, 'months').format("DD/MM/YYYY"),
        params: qs.parse(this.props.location.search),
        hasAll : authService.hasRole("Client User All"),
        isReadOnly : authService.isReadOnly()
      };

      onClose = () => this.setState({open: false});


  onReportGenerate = (selected) => {
    // if the correct one is selected then...
 
    this.downloadDocument(selected);

  }

  componentDidMount = () => {
    this.context.addBreadcrumb({ title: "Reports" , path: '/Reports' });

    ReactGA.pageview('reports');
    if (Object.keys(this.state.params).filter(e => e.toLowerCase() === 'trigger').length > 0) {
       

        this.onReportGenerate((Object.values(this.state.params))[0])
      }

  }

  returnDate =(reportType,item,date) => {

    if(reportType === 'sitereport')
    {
        if(item === "fromDate")
        {
             this.setState({
                sitereportFromDate: date
            });
        }else
        {
            this.setState({
                sitereportToDate: date
            });
        }
    }else if (reportType === 'casereport')
    {
        if(item === "fromDate")
        {
             this.setState({
                casereportFromDate: date
            });
        }else
        {
            this.setState({
                casereportToDate: date
            });
        }
    }else if (reportType === 'costconstracker')
    {
        if(item === "fromDate")
        {
             this.setState({
                costconstrackerFromDate: date
            });
        }else
        {
            this.setState({
                costconstrackerToDate: date
            });
        }
    }else if (reportType === 'supplierinvoicereport')
    {
        if(item === "fromDate")
        {
             this.setState({
                supplierinvoicereportFromDate: date
            });
        }else
        {
            this.setState({
                supplierinvoicereportToDate: date
            });
        }
    }else if (reportType === 'hhdatareport')
    {
        if(item === "fromDate")
        {
             this.setState({
                hhdatareportFromDate: date
            });
        }else
        {
            this.setState({
                hhdatareportToDate: date
            });
        }
    }

  }

  downloadDocument = (reportType) => {
    ReactGA.pageview(reportType);
    var reportname = reportType;

    var bodyFormData = new FormData();
    bodyFormData.append('CustomerKey', authService.getUserData(AuthService.CUSTOMER_ID_KEY));
    bodyFormData.append('User', authService.getUserData(AuthService.EMAIL_KEY));
    bodyFormData.append('ReportType', reportType);

    if (reportType === 'sitereport') {
        bodyFormData.append('toDate', this.state.sitereportToDate);
        bodyFormData.append('fromDate', this.state.sitereportFromDate);
        reportname += this.state.sitereportFromDate + "to" + this.state.sitereportToDate;
    } else if (reportType === 'casereport') {
        bodyFormData.append('toDate', this.state.casereportToDate);
        bodyFormData.append('fromDate', this.state.casereportFromDate);
        reportname += this.state.casereportFromDate + "to" + this.state.casereportToDate;
    } else if (reportType === 'costconstracker') {
        bodyFormData.append('toDate', this.state.costconstrackerToDate);
        bodyFormData.append('fromDate', this.state.costconstrackerFromDate);
        reportname += this.state.costconstrackerFromDate + "to" + this.state.costconstrackerToDate;
    } else if (reportType === 'supplierinvoicereport') {
        bodyFormData.append('toDate', this.state.supplierinvoicereportToDate);
        bodyFormData.append('fromDate', this.state.supplierinvoicereportFromDate);
        reportname += this.state.supplierinvoicereportFromDate + "to" + this.state.supplierinvoicereportToDate;
    } else if (reportType === 'hhdatareport') {
        bodyFormData.append('toDate', this.state.hhdatareportToDate);
        bodyFormData.append('fromDate', this.state.hhdatareportFromDate);
        reportname += this.state.hhdatareportFromDate + "to" + this.state.hhdatareportToDate;
    }

    this.setState({ downloadingReport: true });

    this.attemptDownload(bodyFormData, reportname, 0);
}

attemptDownload = (bodyFormData, reportname, attempt) => {
    axios({
        url: `${apiUrl}/Reports/GetReportOutput`,
        method: 'POST',
        data: bodyFormData,
        timeout: 2000000,
        headers: {
            'Authorization': `bearer ${localStorage.getItem("token")}`
        },
        responseType: 'blob',
    }).then((response) => {
        this.setState({ downloadingReport: false });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', response.data.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ? reportname + '.xlsx' : reportname + '.pdf');
        document.body.appendChild(link);
        link.click();
    }).catch((error) => {
        if (attempt < 3) {
            console.log(`Attempt ${attempt + 1}: Retrying download`);
            this.attemptDownload(bodyFormData, reportname, attempt + 1);
        } else {
            this.setState({ downloadingReport: false });
            console.log("Report download issue: ", error);
            toast.error("An error occurred downloading the report. Please contact your account manager if this continues", {
                position: toast.POSITION.TOP_RIGHT
            });
        }
    });
}


    render() {

        return (
            <div className='main-container'>
                <Helmet>
                    <title>Inenco Portal | Reports</title>
                </Helmet>
               
                                
                                

<Dimmer active={this.state.downloadingReport}>
    <Loader>Preparing Report (This may take a few minutes, depending on the report size)</Loader>
</Dimmer>
                               
                                   
                               
                <Grid padded stackable columns='equal'>
                    <Grid.Row>
                        <Grid.Column>
                            <h2>Reports</h2>
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row>
                        <Grid.Column>
                            <Message warning>
                                <Icon size='large' name='warning sign'/>
                                <b>Please note: </b>Any carbon footprint data shown in the below reports is intended to indicate the scale of carbon 
                                emissions associated with this energy consumption and should not be considered 
                                accurate enough for external carbon reporting. Emissions have been converted using 
                                UK Govt national conversion factors and do not reflect any low-carbon energy tariffs. 
                                If you would like quality-assured carbon data, please contact your account manager.
                            </Message>
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row>
                    {this.state.hasAll &&
                        <Grid.Column>
                            <ReportButton popupText ="PLEASE NOTE - This Report has a fixed date range which cannot be changed" iconName="building outline" text="Portfolio Report" returnDate={this.returnDate} reportType="sitereport" fromDate={this.state.sitereportFromDate} toDate={this.state.sitereportToDate} fixedDates={true} onclickmethod={() => this.onReportGenerate('sitereport')} />
                        </Grid.Column>
                  }
                        <Grid.Column>
                            <ReportButton popupText ="PLEASE NOTE - This Report has a fixed date range which cannot be changed"  iconName="question circle" text="Case Report" returnDate={this.returnDate} reportType="casereport" fromDate={this.state.casereportFromDate} toDate={this.state.casereportToDate} fixedDates={true} onclickmethod={() => this.onReportGenerate('casereport')} />
                        </Grid.Column>
                 
                        <Grid.Column>
                            <ReportButtonMonthly popupHidden={true} iconName="money bill alternate outline" text="Cost Cons Tracker" returnDate={this.returnDate} fromDate={this.state.costconstrackerFromDate} toDate={this.state.costconstrackerToDate} reportType="costconstracker" fixedDates={false}  onclickmethod={() => this.onReportGenerate('costconstracker')} />
                        </Grid.Column>
                
                        <Grid.Column>
                            <ReportButton popupHidden={true} iconName="file alternate outline" text="Supplier Invoice Report" returnDate={this.returnDate} fromDate={this.state.supplierinvoicereportFromDate} toDate={this.state.supplierinvoicereportToDate} reportType="supplierinvoicereport" fixedDates={false}  onclickmethod={() => this.onReportGenerate('supplierinvoicereport')} />
                        </Grid.Column>

                        <Grid.Column>
                            <ReportButton popupHidden={true} iconName="clock outline" text="HH Data Report" returnDate={this.returnDate} fromDate={this.state.hhdatareportFromDate} toDate={this.state.hhdatareportToDate} reportType="hhdatareport" fixedDates={false}   onclickmethod={() => this.onReportGenerate('hhdatareport')} />
                        </Grid.Column>
                    </Grid.Row>

                  
                    
                </Grid>

            </div>
        );
    }
}

const wrap = connect(mapDispatchToProps, mapStateToProps);
export default wrap(Reports);